import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";
import { Box, Button, ListItem, OrderedList, Text } from "@chakra-ui/react";
import React, { useState } from "react";

export default function PaymentMobile() {
  const [open, setOpen] = useState(false);
  return (
    <Box>
      <Box display="flex" px="4" py="2" onClick={() => setOpen(!open)}>
        <Text display="flex" w="full" fontWeight="600" textAlign="left">
          Pembayaran Dari Mobile / Internet Banking Bank Lain
        </Text>
        <Box display="flex" alignItems="center">
          {open ? <ChevronUpIcon /> : <ChevronDownIcon />}
        </Box>
      </Box>
      {open && (
        <OrderedList px="5" spacing={2}>
          <ListItem>
            Login pada aplikasi Mobile / Internet Banking Anda
          </ListItem>
          <ListItem>
            Pilih menu <b>“Transfer”</b>
          </ListItem>
          <ListItem>
            Pilih menu <b>“Transfer Antar Bank”</b>
          </ListItem>
          <ListItem>
            Pilih bank tujuan <b>“Bank BPD Bali”</b>
          </ListItem>
          <ListItem>
            Masukkan nomor rekening tujuan <b> (No Virtual Account)</b>.
          </ListItem>
          <ListItem>
            Input <b>nominal</b> yang ingin ditransfer sesuai <b>tagihan</b>{" "}
            yang ingin dibayar, lalu tekan <b>“Benar”</b>
          </ListItem>
          <ListItem>
            Muncul Layar Konfirmasi Transfer yang berisi nomor rekening tujuan
            bank beserta jumlah yang dibayar
          </ListItem>
          <ListItem>Masukkan Password atau PIN</ListItem>
          <ListItem>Selesai</ListItem>
          <Text>
            Note : tata cara tiap bank mungkin ada sedikit berbeda namun secara
            gambaran umum sama seperti penjelasan diatas.
          </Text>
        </OrderedList>
      )}
    </Box>
  );
}
